
import React from 'react';
import { Loader2 } from 'lucide-react';

export const CalendarSkeleton: React.FC = () => (
  <div className="w-full max-w-4xl mx-auto bg-white rounded-3xl shadow-xl border border-slate-200 overflow-hidden relative min-h-[600px]">
    <div className="p-6 border-b flex justify-between items-center bg-slate-50/50">
      <div className="h-8 w-48 bg-slate-200 animate-pulse rounded-lg"></div>
      <div className="flex gap-2">
        <div className="h-9 w-9 bg-slate-200 animate-pulse rounded-lg"></div>
        <div className="h-9 w-9 bg-slate-200 animate-pulse rounded-lg"></div>
      </div>
    </div>
    <div className="grid grid-cols-7 border-b bg-slate-50">
      {Array(7).fill(0).map((_, i) => (
        <div key={i} className="py-4 px-2 flex justify-center">
          <div className="h-4 w-10 bg-slate-200 animate-pulse rounded"></div>
        </div>
      ))}
    </div>
    <div className="grid grid-cols-7">
      {Array(35).fill(0).map((_, i) => (
        <div key={i} className="h-32 p-2 border-r border-b last:border-r-0 bg-white/50">
          <div className="h-5 w-5 bg-slate-100 animate-pulse rounded mb-2"></div>
        </div>
      ))}
    </div>
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/40 backdrop-blur-sm">
      <div className="bg-white px-8 py-6 rounded-3xl shadow-2xl border border-slate-100 flex flex-col items-center gap-4 animate-fade-in">
        <div className="relative">
          <div className="w-12 h-12 border-4 border-blue-100 rounded-full"></div>
          <Loader2 className="w-12 h-12 text-blue-600 animate-spin absolute top-0 left-0" />
        </div>
        <span className="font-black text-slate-700 tracking-wider">載入預約資料中...</span>
      </div>
    </div>
  </div>
);

export const FormSkeleton: React.FC = () => (
  <div className="w-full max-w-xl mx-auto bg-white p-8 rounded-3xl shadow-xl border border-slate-100 relative overflow-hidden min-h-[500px]">
    <div className="h-10 w-48 bg-slate-100 animate-pulse rounded-xl mb-10"></div>
    <div className="space-y-8">
      <div className="grid grid-cols-2 gap-6">
        <div className="h-14 bg-slate-50 animate-pulse rounded-2xl"></div>
        <div className="h-14 bg-slate-50 animate-pulse rounded-2xl"></div>
      </div>
      <div className="h-14 bg-slate-50 animate-pulse rounded-2xl"></div>
      <div className="h-32 bg-slate-50 animate-pulse rounded-2xl"></div>
      <div className="h-16 bg-slate-100 animate-pulse rounded-2xl"></div>
    </div>
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/40 backdrop-blur-sm">
      <div className="bg-white px-10 py-8 rounded-3xl shadow-2xl border border-slate-100 flex flex-col items-center gap-4 animate-fade-in">
        <div className="relative">
          <div className="w-12 h-12 border-4 border-blue-100 rounded-full"></div>
          <Loader2 className="w-12 h-12 text-blue-600 animate-spin absolute top-0 left-0" />
        </div>
        <span className="font-black text-slate-700 tracking-wider">載入預約資訊中...</span>
      </div>
    </div>
  </div>
);
